// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Screen_wrapper__2IvuJ"};